import {getPaymentMethods} from '../api';
import {createComponent} from '../bridge/create-component';
import type {BridgeComponentOptions} from '../bridge/types';
import {config} from '../config';
import {containerTemplate} from '../container';
import {validateComponentProps} from '../utils';
import type {PaymentRequestProps} from './types';

export * from './types';

const validatePaymentRequestProps = ({props}: {props: PaymentRequestProps}) => {
  validateComponentProps({props});
  if (props.requestShipping && props.paymentId) {
    throw new Error('requestShipping requires accountId flow. Use accountId instead of paymentId.');
  }
};

const componentOptions: BridgeComponentOptions<PaymentRequestProps> = {
  tag: 'monei-payment-request',
  url: config.paymentRequestUrl,
  dimensions: {
    width: '100%',
    height: 'auto'
  },
  autoResize: {
    width: false,
    height: true
  },
  aliases: {
    style: 'innerStyle'
  },
  computedProps: {
    __getConfig: {
      factory: ({props}) => getPaymentMethods.bind(null, props),
      type: 'function'
    }
  },
  validate: validatePaymentRequestProps,
  containerTemplate
};

export const PaymentRequest = createComponent<PaymentRequestProps>(componentOptions);
